/** Name of the feature. */
export const SolanaSignTransaction = 'solana:signTransaction';
